import React, { useEffect, useState } from 'react';
import './styles.scss';
import { withRouter } from 'react-router-dom'
import { Spinner, Image } from 'react-bootstrap'
import Answer from '../CRUD/answer'
import Likes from '../CRUD/likes'
import Saved from '../CRUD/save'
import { FaEye } from 'react-icons/fa'
import Comment from '../CRUD/comment'
import DeletePost from '../CRUD/delete.post'
import Pagination from '../../Text-Editor/Pagination'

function AllQueries(props) {
    const [loader, setLoader] = useState(true);
    const [CurrentPage, setCurrentPage] = useState(1);
    const [currentPosts, setCurrentPosts] = useState([])
    const PostsPerPage = 10;

    useEffect(() => {
        if (props.query) {
            setLoader(false)
        }
        // eslint-disable-next-line
    }, [props.query])

    useEffect(() => {
        //setting current posts
        const indexOfLastPost = CurrentPage * PostsPerPage;
        const indexOfFirstPost = indexOfLastPost - PostsPerPage;
        if (props.query) {
            setCurrentPosts(props.query.slice(indexOfFirstPost, indexOfLastPost))
        }
    }, [props.query, props.history, CurrentPage])

    const getFullComments = (docid) => {
        props.history.push('/community/' + docid)
    }

    //setting current page
    const setCurrent = (e) => {
        setCurrentPage(e)
    }

    return (
        <div className="AllQueries">
            {loader || currentPosts === null ? <center><Spinner animation="border" variant="primary" /></center>
                :
                currentPosts.length === 0 ?
                    <center>No data Retrived 😢 </center>
                    :
                    currentPosts.map((query) => (
                        <div key={query.docid}>
                            <div className="profile">
                                <Image src={query.userimage} />
                                <div>
                                    <p style={{ fontFamily: 'Poppins', fontSize: '14px', color: '#057BD0' }}>{query.username}
                                        <br /><span style={{ fontSize: '12px', fontFamily: 'Viga', color: 'gray' }}>{query.posttime}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="cardDiv" style={{overflowX:'hidden'}}>
                                <h5>{query.title}</h5>
                                <div className="queryDescrip" dangerouslySetInnerHTML={{ __html: query.discrp }}></div>
                                {!query.code ? null :
                                    <>
                                        code:
                                        <div className="scrollMenu Querydescrip">
                                            <div style={{ padding: '10px' }} dangerouslySetInnerHTML={{ __html: query.code }}></div>
                                        </div>
                                    </>
                                }
                                <hr />
                                {query.category === "FEED" ?
                                    <div className="cardFooter">
                                        <p className="footerdiv" style={{ float: 'left' }}><DeletePost docid={query.docid} collection="queries" /></p>
                                        <p className="footerdiv"><Saved docid={query.docid} collection="queries" /></p>
                                        <p className="footerdiv"><Likes docid={query.docid} collection="queries" /></p>
                                        <p className="footerdiv"><Comment docid={query.docid} collection="queries" /></p>
                                    </div>
                                    :
                                    <div className="cardFooter">
                                        <p className="footerdiv" style={{ float: 'left' }}><DeletePost docid={query.docid} collection="queries" /></p>
                                        <p className="footerdiv"><Answer docid={query.docid} /></p>
                                        <p onClick={() => getFullComments(query.docid)} className="footerdiv"><FaEye />{'  '}<span>view all</span></p>
                                    </div>
                                }
                            </div>
                        </div>
                    ))
            }
            <div >
                {!props.query ? null :
                    <Pagination totalPosts={props.query.length} postsPerPage={PostsPerPage} setCurrentPage={setCurrent} />
                }
            </div>
        </div>
    )
}

export default withRouter(AllQueries);
